import {AxiosResponse} from "axios"
import {
  FacilitiesLocksFilterOptions,
  FacilitiesLock,
  NewFacilitiesLock,
  UpdateFacilitiesLock
} from "@/services/models/FacilitiesLock";
import {PagedData} from "@/services/models/shared/PagedData";
import BimsHttpService from "@/services/BimsHttpService";

class FacilitiesLocksService {
    /**
     * @description Returns a paged list of facilities locks
     */
    getFacilitiesLocks(filter: FacilitiesLocksFilterOptions
    ): Promise<PagedData<FacilitiesLock>> {
        return BimsHttpService.get(`/facilitieslocks`, {
            params: filter
        }).then((response: AxiosResponse<PagedData<FacilitiesLock>>) => {
            return response.data as PagedData<FacilitiesLock>;
        });
    }

    /**
     * @description Returns the facilities lock with the specified id
     */
    getFacilitiesLock(id: string): Promise<FacilitiesLock> {
      return BimsHttpService.get(`/facilitieslocks/${id}`).then((response: AxiosResponse<FacilitiesLock>) => {
        return response.data as FacilitiesLock;
        });
    }

    /**
     *  @description Adds new facilities lock
     */
     addFacilitiesLocks(facilitiesLocks: Array<NewFacilitiesLock>): Promise<string> {
      return BimsHttpService.post(`/facilitieslocks`,
        facilitiesLocks
      ).then(response => {
          return response.data
      });
    }

    /**
     * @description Updates the facilities lock
     */
     updateFacilitiesLock(id: string, facilitiesLock: UpdateFacilitiesLock): Promise<any> {
      return BimsHttpService.put(`/facilitieslocks/${id}`,
        facilitiesLock
      )
    }

    /**
     * @description Deletes the facilities lock
     */
    deleteFacilitiesLock(id: string): Promise<any> {
        return BimsHttpService.delete(`/facilitieslocks/${id}`)
    }
}

export default new FacilitiesLocksService();
